import translations from 'messages/widget';
import PropTypes from 'prop-types';
import i18n from '@wix/wix-vod-shared/src/common/i18n';
import styles from './not-available-overlay.styl';

const NotAvailableOverlay = ({ width, height }) => {
  const style = { width, height };

  return (
    <div className={styles.overlay}
         style={style}>
      <div className={styles.title}>{i18n.t(translations.videoNotAvailable)}</div>
      <div className={styles.text}>{i18n.t(translations.checkAgainLater)}</div>
    </div>
  );
};

NotAvailableOverlay.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

export default NotAvailableOverlay;



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/not-available-overlay/not-available-overlay.js